import styled from 'styled-components'
import { flexbox, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

export const Container = styled.div.attrs({
  py: [20, 20, 20, 56],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: ${themeGet('colors.bg.primary')};

  ${padding}
`

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div
  .attrs({
    flexDirection: ['column', 'column', 'column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  width: 100%;
  max-width: ${BLUEPRINT_WIDTH}px;

  ${flexbox}
`
